import { SUSPICIOUS_LOGIN_DIALOG_ID } from "@obg/mat.ui.common";
import { DialogLike } from "@obg/mat.ui.core";
import { map } from "rxjs/operators";

import { SuspiciousLoginContainer } from "./suspicious-login.container";

export const SUSPICIOUS_LOGIN_DIALOG: DialogLike<SuspiciousLoginContainer> = {
	dialogId: SUSPICIOUS_LOGIN_DIALOG_ID,
	dialogComponentType: SuspiciousLoginContainer,
	onBusy$: (c) => c.busy.pipe(map((isBusy) => ({ isBusy }))),
};
